import { useCallback } from 'react';
import { apiErrorMessage } from './ApiClient';
import { useToast } from './ui/Toast';

/*
 * Runs an API call and toasts whatever went wrong. ts-rest resolves a non-2xx
 * response as a value rather than throwing, so awaiting a call without this
 * silently drops real server errors like "It is not your turn". Returns true
 * when the call succeeded, for callers that navigate or roll back on failure.
 */
export function useApiCall() {
  const toast = useToast();

  return useCallback(
    async (call: Promise<{ status: number; body: unknown }>): Promise<boolean> => {
      try {
        const error = apiErrorMessage(await call);
        if (error) toast.error(error);
        return !error;
      } catch {
        toast.error('Could not reach the server.');
        return false;
      }
    },
    [toast],
  );
}
